import React from "react";
import { map } from "lodash-es";

import { Stage } from "shared/assets/icons";
import { buildUrl, useScrollToHashOnFirstRender } from "shared/utils";
import { InfoBlock } from "Venues/components";
import { VENUE_PATHS } from "Venues/router";
import { API_ENDPOINTS } from "shared/constants";
import { useStagePageContext, useVenuePageContext } from "Venues/contexts";
import { EquipmentBlock } from "Venues/containers";
import { useVenueRoute } from "Venues/utils";

export const StageBlocks: React.FC = () => {
  const { getPath } = useVenueRoute();
  const { venueId } = useVenuePageContext();

  // scroll to card according to hash in url on first render
  useScrollToHashOnFirstRender();

  const { stageInfoBlocks, stage, stageId, equipmentCategories } = useStagePageContext();

  if (!stage || !stageId) return null;

  return (
    <>
      {map(
        stageInfoBlocks,
        (infoBlock, index) =>
          infoBlock && (
            <InfoBlock
              key={index}
              infoBlock={infoBlock}
              title={{
                text: stage.title,
                to: getPath(VENUE_PATHS.STAGE, { stageId }),
              }}
              icon={Stage}
              editPath={buildUrl(VENUE_PATHS.EDIT_STAGE_INFO_BLOCK, {
                venueId,
                stageId,
              })}
              extraProps={{ stage: API_ENDPOINTS.STAGE(stageId) }}
            />
          )
      )}
      {equipmentCategories.map(category => (
        <EquipmentBlock key={category.category} category={category} />
      ))}
    </>
  );
};
